"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _reactResponsiveModal = _interopRequireDefault(require("react-responsive-modal"));

require("react-responsive-modal/styles.css");

var _Button = _interopRequireDefault(require("../Button"));

var _excluded = ["children", "label", "showCloseButton", "closeButtonText", "options", "onClosePopup", "withPadding", "className", "isInitialOpen"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var styles = {
  overlay: {
    zIndex: 10001,
    background: 'rgba(145,148,153,.5)'
  },
  modal: {
    padding: 0,
    borderRadius: 4
  },
  closeButton: {
    zIndex: 9,
    top: 6,
    right: 10
  }
};
var defaultPadding = 10;
var buttonHeight = 50; // react-responsive-modal props

var DEFAULT_OPTIONS = {
  showCloseIcon: true,
  center: true,
  focusTrapped: false
};

var MobilePopup = function MobilePopup(_ref) {
  var children = _ref.children,
      label = _ref.label,
      showCloseButton = _ref.showCloseButton,
      closeButtonText = _ref.closeButtonText,
      options = _ref.options,
      onClosePopup = _ref.onClosePopup,
      withPadding = _ref.withPadding,
      className = _ref.className,
      _ref$isInitialOpen = _ref.isInitialOpen,
      isInitialOpen = _ref$isInitialOpen === void 0 ? false : _ref$isInitialOpen,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useState = (0, _react.useState)(isInitialOpen),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  (0, _react.useEffect)(function () {
    setOpen(isInitialOpen);
  }, [isInitialOpen]);

  var onClose = function onClose() {
    setOpen(false);
    onClosePopup();
  };

  var onOpen = function onOpen() {
    return setOpen(true);
  };

  var modalParams = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);

  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    _react["default"].createElement("div", rest, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      functional: true,
      onClick: onOpen
    }, label), /*#__PURE__*/_react["default"].createElement(_reactResponsiveModal["default"], (0, _extends2["default"])({
      open: isOpen,
      styles: styles,
      onClose: onClose
    }, modalParams), /*#__PURE__*/_react["default"].createElement(StyledContainer, {
      className: className,
      withPadding: withPadding
    }, /*#__PURE__*/_react["default"].createElement(StyledContent, {
      withButton: showCloseButton
    }, children), showCloseButton && /*#__PURE__*/_react["default"].createElement(StyledCloseButtonWrapper, {
      withMargin: !withPadding
    }, /*#__PURE__*/_react["default"].createElement(StyledCloseButton, {
      onClick: onClose
    }, closeButtonText)))))
  );
};

MobilePopup.propTypes = {
  className: _propTypes["default"].string,
  closeButtonText: _propTypes["default"].string,
  label: _propTypes["default"].node.isRequired,
  children: _propTypes["default"].node.isRequired,
  showCloseButton: _propTypes["default"].bool,
  // react-responsive-modal props
  options: _propTypes["default"].shape({}),
  onClosePopup: _propTypes["default"].func,
  withPadding: _propTypes["default"].bool
};
MobilePopup.defaultProps = {
  className: '',
  closeButtonText: 'Закрыть',
  showCloseButton: false,
  options: {},
  onClosePopup: Function.prototype,
  withPadding: true
};

var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "MobilePopup__StyledContainer",
  componentId: "sc-5ofcd7-0"
})(["position:relative;background:", ";max-width:95vw;min-width:250px;max-height:90vh;box-shadow:0 0 0 1px rgb(187,187,187);border-radius:4px;padding:", ";overflow:hidden;"], function (props) {
  return props.theme.colors.white;
}, function (_ref2) {
  var withPadding = _ref2.withPadding;
  return withPadding && "".concat(defaultPadding, "px");
});

var StyledContent = _styledComponents["default"].div.withConfig({
  displayName: "MobilePopup__StyledContent",
  componentId: "sc-5ofcd7-1"
})(["max-height:", ";overflow:auto;&:after{content:'';position:absolute;bottom:", "px;width:", ";height:10px;background:linear-gradient( rgba(255,255,255,0.001),", " );pointer-events:none;}"], function (props) {
  return props.withButton ? 'calc(90vh - 75px)' : '90vh';
}, buttonHeight + defaultPadding, function (_ref3) {
  var withPadding = _ref3.withPadding;
  return "calc(100% - ".concat(withPadding ? defaultPadding * 2 : 0, "px)");
}, function (props) {
  return props.theme.colors.white;
});

var StyledCloseButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "MobilePopup__StyledCloseButton",
  componentId: "sc-5ofcd7-2"
})(["width:100%;height:", "px;background:", ";font-size:15px;"], buttonHeight, function (props) {
  return props.theme.colors.white;
});

var StyledCloseButtonWrapper = _styledComponents["default"].div.withConfig({
  displayName: "MobilePopup__StyledCloseButtonWrapper",
  componentId: "sc-5ofcd7-3"
})(["", ""], function (_ref4) {
  var withMargin = _ref4.withMargin;
  return withMargin && (0, _styledComponents.css)(["margin:0 ", "px ", "px;"], defaultPadding, defaultPadding);
});

MobilePopup.StyledContainer = StyledContainer;
var _default = MobilePopup;
exports["default"] = _default;